















































































































































































import Vue, { PropType } from 'vue'
import dayjs from 'dayjs'
import { getImageUrl } from '@/utils/helper'
import Icon from '@/components/globals/Icon.vue'
// import Stars from '@/components/globals/basics/Rating/Stars.vue';
import {
  ProgramWithTimetables,
  programLevelLabels,
  programGenderLabels,
  groupTimetablesByAvailableDateAndTimeSpan,
} from '@/core/Programs'
import { Timetable } from '@/core/Timetables'

const TIMETABLE_DISPLAY_LIMIT = 4

export default Vue.extend({
  components: {
    Icon,
    // Stars
  },
  filters: {
    formatDate(date: string): string {
      return dayjs(date).format('YYYY / MM / DD')
    },
    firstFourItems(arr: any[]) {
      return arr.slice(0, 4)
    },
    formatScore(score: number) {
      const floatValue = score - Math.floor(score)
      // 小数点以下がない場合は.0をsuffixする
      return floatValue === 0 ? `${score}.0` : score
    },
  },
  props: {
    program: {
      type: Object as PropType<ProgramWithTimetables>,
      required: true,
    },
  },
  computed: {
    levelLabel(): string {
      return programLevelLabels[this.program.level]
    },
    sexLimitationLabel(): string {
      return programGenderLabels[this.program.sexLimitation]
    },
    formattedPoint(): string {
      return this.program.minTimetablePoint === this.program.maxTimetablePoint
        ? this.$numberFormat(this.program.minTimetablePoint) + 'pt'
        : this.$numberFormat(this.program.minTimetablePoint) + 'pt~'
    },
    groupedTimetables(): {
      [date: string]: { [timespan: string]: Timetable[] }
    } {
      return groupTimetablesByAvailableDateAndTimeSpan(
        this.program.timetables,
        TIMETABLE_DISPLAY_LIMIT
      )
    },
  },
  methods: {
    getImageUrl: getImageUrl,
    hasStock(timetables: Timetable[]): boolean {
      if (!timetables) return false
      return timetables.reduce((acc, timetable) => acc + timetable.stock, 0) > 0
    },
  },
})
